import { ControlConnector } from "@multiweb/reactConnectors/ControlConnector";
import { IAttrValue } from "@multiweb/types/contracts";
import { ReactComponentTemplate } from "UI/UI.Controls/DataGridSubcontrols/Templates/DataTypeTemplates/ReactComponentTemplate";
import { LinkAttribute } from "UI/UI.React/frames/components";
import { AttrValueReader } from "../../../../../../OW.Remoting/Remoting/AttrValueReader";
import { Column } from "../../../../../UI.Controls/DataGridSubcontrols/Columns/Column";
import { registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IRequiresMasterObject } from "./IRequiresMasterObject";
import { LinkEditTemplate } from "./Templates/LinkEditTemplate";

export class LinkColumn extends Column implements IRequiresMasterObject {
    //#region Fields
    public requiresMasterObject: boolean = true;
    public override get trimValue(): boolean {
        return false;
    }
    //#endregion Fields

    protected static get _observedAttributes(): string[] {
        return /*["enumname", "data-allowsignwithoutedit"].concat*/(Column.observedAttributes);
    }
    //#region Methods

    public override async formatValue(data: IAttrValue | IAttrValue[]): Promise<string> {
        if (data instanceof Array) {
            if (data.length > 0)
                data = data[0];
            else
                return "";
        }

        const val = AttrValueReader.read(data);
        if (val == null || val === "")
            return "";

        if (typeof val === "string") {
            const lastColon = val.lastIndexOf(":");
            return lastColon !== -1 ? val.substr(lastColon + 1) : val;
        }

        return "";
    }

    //#endregion Methods

    //#region HTMLElement
    protected override _constructor(): void {
        super._constructor();

        this.requiresMasterObject = true;
        this.itemTemplate = new ReactComponentTemplate(LinkAttribute, ControlConnector);
        this.editItemTemplate = new LinkEditTemplate();
    }

    protected override attributeChangedCallback(attrName: string, oldVal: string, newVal: string): void {
        super.attributeChangedCallback(attrName, oldVal, newVal);
    }
    //#endregion HTMLElement

    public override dispose(): void {
        super.dispose();
    }
} //end Column

registerCustomElement("tsc-xgLinkColumn", LinkColumn);
